// Banks offered in every bank field. Add new banks here and every bank field picks them up.
export const SRI_LANKAN_BANKS = [
  'Bank of Ceylon',
  "People's Bank",
  'Sampath Bank',
  'National Savings Bank',
  'Commercial Bank of Ceylon',
  'Hatton National Bank',
  'Seylan Bank',
  'DFCC Bank',
  'National Development Bank',
  'Regional Development Bank',
  'Nations Trust Bank',
  'Amana Bank',
  'Union Bank of Colombo',
  'Sanasa Development Bank',
];

export const OTHER_BANK = 'Other';
